import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { PaymentPlan } from '../model/payment-plan';
import { BillingOptionsService } from '../services/billing-options.service';
import { OneIncService } from '../services/one-inc.service';

@Component({
  selector: 'app-payment-form',
  templateUrl: './payment-form.component.html',
  styleUrls: ['./payment-form.component.css']
})
export class PaymentFormComponent implements OnInit {
  minimumDate: Date;
  maximumDate: Date;
  paymentForm = this.fb.group({
    paymentAmount: [''],
    paymentDate: [new Date()]
  });
  paymentPlan: PaymentPlan;

  constructor(private billingOptionsService: BillingOptionsService,
              private oneIncService: OneIncService,
              private fb: FormBuilder) {
    this.minimumDate = new Date();
    this.maximumDate = new Date(
        this.minimumDate.getFullYear(),
        this.minimumDate.getMonth(),
        this.minimumDate.getDate() + 14
    );
  }

  ngOnInit() {
    this.getPaymentPlan();
  }

  isButtonDisabled(): boolean {
    return this.paymentForm.get('paymentAmount').value === '' ||
        this.paymentForm.get('paymentDate').value === null;
  }

  getPaymentPlan(): void {
    this.paymentPlan = this.billingOptionsService.getSelectedPaymentPlan();
  }

  selectPaymentCategory(paymentCategory: string): void {
    const amount = this.paymentForm.get('paymentAmount').value === 'minimum' ?
        this.paymentPlan.downPayment :
        this.paymentPlan.netDue;
    const date = this.paymentForm.get('paymentDate').value;
    this.oneIncService.startOneIncProcess(paymentCategory, amount, date);
  }
}
